module.exports = __webpack_public_path__ + "static/media/ab_notify_client_en.9564ab47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ab_notify_client_en.svg
// module id = 1259
// module chunks = 0